/* Puts assets/onesto-cookie-banner.css inside the Pandectes GDPR app's cookie banner.
   Pandectes renders the banner in an open shadow root on <pandectes-cmp>, which page CSS can't reach,
   so a <link> to the theme stylesheet is appended to that shadow root once it exists - and again if
   Pandectes re-renders its contents. The stylesheet URL comes from this script tag's data-css. */
(() => {
  const script = document.currentScript;
  const href = script && script.dataset.css;
  if (!href || window.onestoCookieBannerReady) return;
  window.onestoCookieBannerReady = true;

  const ensureLink = (root) => {
    if (root.querySelector('link[data-onesto-cookie-css]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-onesto-cookie-css', '');
    root.appendChild(link);
  };

  const attach = (host) => {
    if (host.dataset.onestoStyled) return;
    const root = host.shadowRoot;
    if (!root) return;
    host.dataset.onestoStyled = 'true';
    ensureLink(root);
    // Pandectes re-renders its shadow content (notice -> preferences -> widget)
    new MutationObserver(() => ensureLink(root)).observe(root, { childList: true });
  };

  let pageObserver;
  let poll;
  const scan = () => {
    document.querySelectorAll('pandectes-cmp').forEach(attach);
    const host = document.querySelector('pandectes-cmp');
    if (host && host.dataset.onestoStyled) {
      // styled - stop watching the whole page
      if (pageObserver) pageObserver.disconnect();
      clearInterval(poll);
    }
  };

  // the host is appended to <body> by the app embed; its shadow root may be attached a moment later
  pageObserver = new MutationObserver(scan);
  pageObserver.observe(document.body || document.documentElement, { childList: true });
  let tries = 0;
  poll = setInterval(() => {
    tries += 1;
    if (tries > 150) clearInterval(poll);
    scan();
  }, 100);
  scan();
})();
